import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Location } from 'vue-router';
import { Moment } from 'moment';
import { EdgePatientEnrollmentApi, EnrollmentExtV2Api, EdgeCouponApi } from '@trialcard/apigateway.client';
import { EnrollmentResultModelResponse } from '@trialcard/apigateway.models';
import { Gender } from '@trialcard/enums';
import { Resolve } from 'vue-di';
import EligibilityModule from './eligibility';
import { OnClear } from '~/services/clearModule';
import { clearRecords } from '~/services/clearRecords';
import { Settings } from '~/services/settings';

@InjectModule({ stateFactory: true }, module)
@OnClear<PatientModule>(async value => value.clear())
export default class PatientModule extends InjectVuexModule {
    @Resolve
    public patientEnrollmentApi!: EdgePatientEnrollmentApi;

    @Resolve
    public EdgeCouponApi!: EdgeCouponApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    public eligibility!: EligibilityModule;

    public patientInformation = {
        firstName: '',
        lastName: '',
        dateOfBirth: null as Moment | string | null,
        gender: 0 as Gender,
        addresses: [
            {
                addressOne: '',
                addressTwo: '',
                zip: '',
                city: '',
                state: '',
            },
        ],
        phoneNumbers: [
            {
                phoneNumber: '',
            },
        ],
        emailAddresses: [
            {
                address: '',
            },
        ],
    };
    insuranceInformationData = {
      insuranceName: '',
      insuranceBin: '',
      insurancePcn: '',
      insuranceGroup:''
    } ;
    public demographicInformation = {
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        email: '',
        homePhone: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
    };

    @Mutation
    public clear() {
        clearRecords(this.patientInformation);
        clearRecords(this.insuranceInformationData);
    }

    @Mutation
    public updatePatientInformation(data: typeof PatientModule.prototype.patientInformation) {
        Object.assign(this.patientInformation, data);
    }

    @Mutation
    public updateDemographicInformation(data: typeof PatientModule.prototype.demographicInformation) {
        Object.assign(this.demographicInformation, data);
    }
    @Mutation
    public updateInsuranceInformationData(data: typeof PatientModule.prototype.insuranceInformationData) {
       this.insuranceInformationData = data;
    }
    /*

    @Action({})
    public async submit() {
        try {
            await this.uploadDocument();
            const site = await this.createSite();
            const prescriber = await this.createPrescriber();
            await this.enrollPatient(site, prescriber);
        } catch {
            //error page
            return;
        }
        this.clear();
        return;
    }
    */

    @Action({})
    public async submit() {
        let response: EnrollmentResultModelResponse = { success: false };

        const request = {
            survey: this.eligibility.eligibilityData,
            demographics: this.demographicInformation,
            insuranceVerification : {
                    payerName: this.insuranceInformationData.insuranceName,
                    bin: this.insuranceInformationData.insuranceBin,
                    pcn: this.insuranceInformationData.insurancePcn,
                    payerPhone: '0',
                    payerMedicalId: ''
                },
        };
        try {
            response = (await this.EdgeCouponApi.enrollmentEnrollmentWithInsurance(
                +this.settings.programId,
                request
                // +this.settings.programId
            )).data;
        } catch (error) {
            console.log(error);
        }
        return response;
    }
}
